var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "map-pin",
    clipPath: "url(#clip0_10776_13076)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.5 5.96094C10.5 9.46094 6 12.4609 6 12.4609C6 12.4609 1.5 9.46094 1.5 5.96094C1.5 4.76746 1.97411 3.62287 2.81802 2.77896C3.66193 1.93504 4.80653 1.46094 6 1.46094C7.19347 1.46094 8.33807 1.93504 9.18198 2.77896C10.0259 3.62287 10.5 4.76746 10.5 5.96094Z",
    fill: "#898989",
    stroke: "#898989",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6 7.46094C6.82843 7.46094 7.5 6.78937 7.5 5.96094C7.5 5.13251 6.82843 4.46094 6 4.46094C5.17157 4.46094 4.5 5.13251 4.5 5.96094C4.5 6.78937 5.17157 7.46094 6 7.46094Z",
    fill: "#2C2C2C",
    stroke: "#2C2C2C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10776_13076"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 0.960938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/map-pin.abb59ca47aaf89bc7cb2dc03b735bbd4.svg";
export { ForwardRef as ReactComponent };